export const MiscBulkEditEvents = {
  CHANGE_BULK_ITEM_EDIT_SHEET: 'Change Bulk Item Edit Sheet',
  CLICK_BUTTON: 'Click Button',
  SUBMIT_SERVER_REQUEST: 'Submit Server Request',
  VIEW: 'View',
  VIEW_ELEMENT: 'View Element'
};
export const BulkActionsEvents = {
  ITEM_UPDATED_ERROR: 'Bulk Actions: Items Updated - Error',
  ITEM_UPDATED_SUCCESS: 'Bulk Actions: Items Updated - Success',
  MODAL_DISMISEED: 'Bulk Actions: Modal Dismissed',
  MODAL_OPENED: 'Bulk Actions: Modal Opened',
  MODAL_UPDATE_INITIATED: 'Bulk Actions: Modal Update Initiated'
};
export const BulkItemEditEvents = {
  ABORTED: 'Bulk Item Edit: Aborted',
  COLUMN_ADDED: 'Bulk Item Edit: Column Added',
  EDITED_FIELD: 'Bulk Item Edit: Edited Field',
  FAILED: 'Bulk Item Edit: Failed',
  ROW_ADDED: 'Bulk Item Edit: Row Added',
  SHEET_OPENED: 'Bulk Item Edit: Sheet Opened',
  SUCCESS: 'Bulk Item Edit: Success',
  UPDLOAD_IMAGE_MODAL: 'Bulk Item Edit: Upload Image Modal',
  BULK_IMAGE_UPLOAD: 'Bulk Item Edit: Bulk Image Upload'
};